import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ahaApi from "../../app/services/aha-api";

const initialState = {
  value: {},
  loading: false,
};

export const fetchDataByPartnerOrderId = createAsyncThunk(
  "homeHealth/fetchDataByPartnerOrderId",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getDataByPartnerOrderId(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const fetchDataByPartnerOrderIdSlice = createSlice({
  name: "fetchDataByPartnerOrderId",
  initialState,
  reducers: {
    clearDataByPartnerOrderd(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataByPartnerOrderId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataByPartnerOrderId.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(fetchDataByPartnerOrderId.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const dataByPartnerOrderId = (state) => state.dataByPartnerOrderId.value;
export const dataByPartnerOrderIdLoader = (state) => state.dataByPartnerOrderId.loading;
export const { clearDataByPartnerOrderd } = fetchDataByPartnerOrderIdSlice.actions;
export default fetchDataByPartnerOrderIdSlice.reducer;
